import React, {Component} from 'react';
import Relay from 'react-relay';
import cookie from '../../helper/cookie'

import Sidebar from '../../components/Sidebar';
import AllProjects from './allProjects';

class Allprojectspage extends Component
{ 
  constructor(props){
    super(props);
    var data = [];
    this.props.viewer.allProjects.map((object, index) => {
      var date = new Date(object.startDate);
      date = String(date).split(" ")[2] + ' ' + String(date).split(" ")[1] + ', ' + String(date).split(" ")[3];
      var agentPicture,agentName;
      if (object.agent == null){
        agentPicture="http://dndw32r4edmw5.cloudfront.net/avatar/Male.png",
        agentName="Not Assigned"
      }
      else{
        agentPicture=object.agent.picture,
        agentName=object.agent.name
      }
      data.push({
        id: object.pid,
        projectname:object.name,
        status:object.status,
        customerimg:object.customer.picture,
        agentimg:agentPicture,
        customername:object.customer.email.split("@")[0],
        agentname:agentName,
        dos:date,
        lastactivity:"2:46 pm"
      });
    });
    this.state={allprojects:data};
  }

  render()
  {
    if (cookie.get('access_token') != null) {
      return(
          <div>
            <div className="row">
              <div className="col-md-1 col-sm-1">
                <div className="col-md-12" style={{backgroundColor:"#e5e5e5",height:"100%"}}>
                  <Sidebar source="projects"/>
                </div>
              </div>
              <div className="col-md-11 col-sm-11" id='root'>
                  <AllProjects dataArray={this.state.allprojects} />
              </div>
            </div>
          </div>
      );
       }
  else{
    window.location.href = "/#/login";
    return(<div></div>);
  }
  }
}

export default Relay.createContainer(Allprojectspage, {
  initialVariables: {
    status: null
  },
  fragments: {
    viewer: () => Relay.QL`
      fragment on Agent {
        allProjects{
          id
          pid
          name
          status
          customer{
            name
            email
            picture
          }
          agent{
            name
            picture
          }
          startDate
        }
      }
    `
  }
});




/** WEBPACK FOOTER **
 ** ./src/views/AllProjects/index.js
 **/